import { createCrudService } from '@/services/api/createCrudService'
import { api } from '@/services/api/AxiosBaseService'
import type { BackupFile } from '@/services/modules/BackupsService'

export interface DegreeRelationship {
  id: string
  degreeRelationship: string
  code: string | null
  exportCode: string | null
  /** Código Zelo quando o dependente é do gênero masculino (vazio = usa o padrão). */
  exportCodeMale: string | null
  /** Código Zelo quando o dependente é do gênero feminino (vazio = usa o padrão). */
  exportCodeFemale: string | null
  gender: 'MASCULINO' | 'FEMININO' | 'OUTRO' | null
  status: 'ATIVO' | 'INATIVO'
}

export const DegreeRelationshipsService = createCrudService<DegreeRelationship>('/settings/degree-relationships', { searchField: 'degree_relationship' })

/** Grau que não existe mais (no backup) ou está excluído, e quem ficou sem ele. */
export interface DegreeRecoveryItem {
  id: string
  /** `backup`: lido do backup (excluído antes da lixeira existir); `sistema`: está na lixeira. */
  source: 'backup' | 'sistema'
  name: string
  code: string | null
  dependents: { semGrau: number; ativos: number; inativos: number; jaCorrigidos: number }
  /** Regras de planos/produtos/relatórios que tinham o grau. */
  rules: Array<{ label: string; count: number }>
  /** Grau ativo de mesmo nome, quando existe. */
  suggested: string | null
}

export interface DegreeRecoveryPreview {
  token: string
  backup: string | null
  items: DegreeRecoveryItem[]
  targets: Array<{ id: string; name: string }>
}

export const DegreeRecoveryService = {
  async backups() {
    const { data } = await api.get<{ data: { backups: BackupFile[]; suggested: string | null } }>('/settings/degree-relationships/recovery/backups')
    return data.data
  },
  async preview(backupPath: string | null) {
    const { data } = await api.post<{ data: DegreeRecoveryPreview }>('/settings/degree-relationships/recovery/preview', { backupPath }, { timeout: 300_000 })
    return data.data
  },
  async apply(token: string, mapping: Array<{ oldId: string; targetId: string | null }>) {
    const { data } = await api.post<{ data: { dependents: number; rules: number } }>('/settings/degree-relationships/recovery/apply', { token, mapping })
    return data.data
  },
}
